import script from "./StanderdMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./StanderdMsg.vue?vue&type=script&setup=true&lang=js"

import "./StanderdMsg.vue?vue&type=style&index=0&id=afd9a294&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd9a294"]])

export default __exports__